

import { BankRoles, ProviderRoles, InspectorRoles, UserRole } from '@/shared/enums/UserRoles';

export interface ReportsAccessConfig {
  
  canViewReports: boolean;
  canExportPanorama: boolean;

  
  autoFilters: {
    providerId?: string;
    inspectorId?: string;
    statusFilter?: string[];
  };

  
  availableTabs: string[];


  visibleCharts: {
    overview: string[];
    temporal: string[];
    performance: string[];
    geographic: string[];
    quality?: string[];
  };

  
  availableFilterFields: {
    dateRange: boolean;
    provider: boolean;
    inspector: boolean;
    status: boolean;
  };
}


export const CHART_IDS = {
  
  KPIS: 'kpis',
  STATUS_DISTRIBUTION: 'status-distribution',
  INSPECTION_TYPE_DISTRIBUTION: 'inspection-type-distribution',
  TOP_INSPECTORS: 'top-inspectors',
  TOP_PROVIDERS: 'top-providers',
  TOP_CITIES: 'top-cities',

  
  MONTHLY_EVOLUTION: 'monthly-evolution',
  COMPLETION_TREND: 'completion-trend',
  MONTHLY_STATUS_BREAKDOWN: 'monthly-status-breakdown',
  YEAR_COMPARISON: 'year-comparison',


  REJECTION_RATE: 'rejection-rate',
  INSPECTOR_PRODUCTIVITY: 'inspector-productivity',
  PROVIDER_COMPARISON: 'provider-comparison',


  GEOGRAPHIC_HEATMAP: 'geographic-heatmap',


  PROCESS_FUNNEL: 'process-funnel',
  VOLUME_QUALITY: 'volume-quality',
} as const;


const ROLE_ACCESS_CONFIGS: Record<UserRole, ReportsAccessConfig> = {

  
  
  

  [BankRoles.ADMIN_BANK]: {
    canViewReports: true,
    canExportPanorama: true,
    autoFilters: {},
    availableTabs: ['1', '2', '3', '4'],
    visibleCharts: {
      overview: [
        CHART_IDS.KPIS,
        CHART_IDS.STATUS_DISTRIBUTION,
        CHART_IDS.INSPECTION_TYPE_DISTRIBUTION,
        CHART_IDS.TOP_INSPECTORS,
        CHART_IDS.TOP_PROVIDERS,
        CHART_IDS.TOP_CITIES,
      ],
      temporal: [
        CHART_IDS.MONTHLY_EVOLUTION,
        CHART_IDS.COMPLETION_TREND,
        CHART_IDS.MONTHLY_STATUS_BREAKDOWN,
        CHART_IDS.YEAR_COMPARISON,
      ],
      performance: [
        CHART_IDS.REJECTION_RATE,
        CHART_IDS.INSPECTOR_PRODUCTIVITY,
        CHART_IDS.PROVIDER_COMPARISON,
      ],
      geographic: [CHART_IDS.GEOGRAPHIC_HEATMAP],
    },
    availableFilterFields: {
      dateRange: true,
      provider: true,
      inspector: true,
      status: true,
    },
  },

  [BankRoles.BANK_OPERATIONAL]: {
    canViewReports: true,
    canExportPanorama: false, 
    autoFilters: {},
    availableTabs: ['1', '2', '3', '4'],
    visibleCharts: {
      overview: [
        CHART_IDS.KPIS,
        CHART_IDS.STATUS_DISTRIBUTION,
        CHART_IDS.INSPECTION_TYPE_DISTRIBUTION,
        CHART_IDS.TOP_INSPECTORS,
        CHART_IDS.TOP_PROVIDERS,
        CHART_IDS.TOP_CITIES,
      ],
      temporal: [
        CHART_IDS.MONTHLY_EVOLUTION,
        CHART_IDS.COMPLETION_TREND,
        CHART_IDS.MONTHLY_STATUS_BREAKDOWN,
        CHART_IDS.YEAR_COMPARISON,
      ],
      performance: [
        CHART_IDS.REJECTION_RATE,
        CHART_IDS.INSPECTOR_PRODUCTIVITY,
        CHART_IDS.PROVIDER_COMPARISON,
      ],
      geographic: [CHART_IDS.GEOGRAPHIC_HEATMAP],
    },
    availableFilterFields: {
      dateRange: true,
      provider: true,
      inspector: true,
      status: true,
    },
  },

  [BankRoles.ENG_MANAGEMENT]: {
    canViewReports: true,
    canExportPanorama: true,
    autoFilters: {},
    availableTabs: ['1', '2', '3', '4'],
    visibleCharts: {
      overview: [
        CHART_IDS.KPIS,
        CHART_IDS.STATUS_DISTRIBUTION,
        CHART_IDS.INSPECTION_TYPE_DISTRIBUTION,
        CHART_IDS.TOP_INSPECTORS,
        CHART_IDS.TOP_PROVIDERS,
        CHART_IDS.TOP_CITIES,
      ],
      temporal: [
        CHART_IDS.MONTHLY_EVOLUTION,
        CHART_IDS.COMPLETION_TREND,
        CHART_IDS.MONTHLY_STATUS_BREAKDOWN,
        CHART_IDS.YEAR_COMPARISON,
      ],
      performance: [
        CHART_IDS.REJECTION_RATE,
        CHART_IDS.INSPECTOR_PRODUCTIVITY,
        CHART_IDS.PROVIDER_COMPARISON,
      ],
      geographic: [CHART_IDS.GEOGRAPHIC_HEATMAP],
    },
    availableFilterFields: {
      dateRange: true,
      provider: true,
      inspector: true,
      status: true,
    },
  },

  [BankRoles.ACCESS_MANAGER]: {
    canViewReports: true,
    canExportPanorama: false,
    autoFilters: {},
    availableTabs: ['1', '2', '3', '4'],
    visibleCharts: {
      overview: [
        CHART_IDS.KPIS,
        CHART_IDS.STATUS_DISTRIBUTION,
        CHART_IDS.INSPECTION_TYPE_DISTRIBUTION,
        CHART_IDS.TOP_INSPECTORS,
        CHART_IDS.TOP_PROVIDERS,
        CHART_IDS.TOP_CITIES,
      ],
      temporal: [
        CHART_IDS.MONTHLY_EVOLUTION,
        CHART_IDS.COMPLETION_TREND,
        CHART_IDS.MONTHLY_STATUS_BREAKDOWN,
        CHART_IDS.YEAR_COMPARISON,
      ],
      performance: [
        CHART_IDS.REJECTION_RATE,
        CHART_IDS.INSPECTOR_PRODUCTIVITY,
        CHART_IDS.PROVIDER_COMPARISON,
      ],
      geographic: [CHART_IDS.GEOGRAPHIC_HEATMAP],
    },
    availableFilterFields: {
      dateRange: true,
      provider: true,
      inspector: true,
      status: true,
    },
  },

  
  
  

  [BankRoles.ANTI_FRAUD]: {
    canViewReports: true,
    canExportPanorama: false,
    autoFilters: {
      statusFilter: ['Finalizado', 'LaudoAceitoPeloBanco', 'Aprovado'],
    },
    availableTabs: ['1', '2', '4'], 
    visibleCharts: {
      overview: [
        CHART_IDS.KPIS,
        CHART_IDS.STATUS_DISTRIBUTION,
        CHART_IDS.INSPECTION_TYPE_DISTRIBUTION,
        
      ],
      temporal: [
        CHART_IDS.MONTHLY_EVOLUTION,
        CHART_IDS.COMPLETION_TREND,
        CHART_IDS.YEAR_COMPARISON,
      ],
      performance: [], 
      geographic: [CHART_IDS.GEOGRAPHIC_HEATMAP],
    },
    availableFilterFields: {
      dateRange: true,
      provider: false, 
      inspector: false, 
      status: false, 
    },
  },

  
  
  

  [BankRoles.CONSULTANT]: {
    canViewReports: true,
    canExportPanorama: false,
    autoFilters: {},
    availableTabs: ['1', '2'], 
    visibleCharts: {
      overview: [
        CHART_IDS.KPIS,
        CHART_IDS.STATUS_DISTRIBUTION,
        CHART_IDS.INSPECTION_TYPE_DISTRIBUTION,
      ],
      temporal: [
        CHART_IDS.MONTHLY_EVOLUTION,
        CHART_IDS.COMPLETION_TREND,
      ],
      performance: [],
      geographic: [],
    },
    availableFilterFields: {
      dateRange: true,
      provider: false,
      inspector: false,
      status: true,
    },
  },

  
  
  

  [ProviderRoles.MASTER_PROVIDER]: {
    canViewReports: true,
    canExportPanorama: false,
    autoFilters: {
      
    },
    availableTabs: ['1', '2', '3', '4'],
    visibleCharts: {
      overview: [
        CHART_IDS.KPIS,
        CHART_IDS.STATUS_DISTRIBUTION,
        CHART_IDS.INSPECTION_TYPE_DISTRIBUTION,
        CHART_IDS.TOP_INSPECTORS, 
        CHART_IDS.TOP_PROVIDERS, 
        CHART_IDS.TOP_CITIES, 
      ],
      temporal: [
        CHART_IDS.MONTHLY_EVOLUTION,
        CHART_IDS.COMPLETION_TREND,
        CHART_IDS.MONTHLY_STATUS_BREAKDOWN,
        CHART_IDS.YEAR_COMPARISON,
      ],
      performance: [
        CHART_IDS.REJECTION_RATE, 
        CHART_IDS.INSPECTOR_PRODUCTIVITY, 
        CHART_IDS.PROVIDER_COMPARISON, 
      ],
      geographic: [CHART_IDS.GEOGRAPHIC_HEATMAP],
    },
    availableFilterFields: {
      dateRange: true,
      provider: false, 
      inspector: true,  
      status: true,
    },
  },

  [ProviderRoles.PROVIDER_OPERATIONAL]: {
    canViewReports: true,
    canExportPanorama: false,
    autoFilters: {
      
    },
    availableTabs: ['1', '2', '3', '4'],
    visibleCharts: {
      overview: [
        CHART_IDS.KPIS,
        CHART_IDS.STATUS_DISTRIBUTION,
        CHART_IDS.INSPECTION_TYPE_DISTRIBUTION,
        CHART_IDS.TOP_INSPECTORS, 
        CHART_IDS.TOP_CITIES,
      ],
      temporal: [
        CHART_IDS.MONTHLY_EVOLUTION,
        CHART_IDS.COMPLETION_TREND,
        CHART_IDS.MONTHLY_STATUS_BREAKDOWN,
        CHART_IDS.YEAR_COMPARISON,
      ],
      performance: [
        CHART_IDS.INSPECTOR_PRODUCTIVITY,
      ],
      geographic: [CHART_IDS.GEOGRAPHIC_HEATMAP],
    },
    availableFilterFields: {
      dateRange: true,
      provider: false,
      inspector: true,
      status: true,
    },
  },

  [ProviderRoles.REPORT_ANALYST]: {
    canViewReports: true,
    canExportPanorama: false,
    autoFilters: {
      
    },
    availableTabs: ['1', '2'], 
    visibleCharts: {
      overview: [
        CHART_IDS.KPIS,
        CHART_IDS.STATUS_DISTRIBUTION,
        CHART_IDS.INSPECTION_TYPE_DISTRIBUTION,
        CHART_IDS.TOP_INSPECTORS,
      ],
      temporal: [
        CHART_IDS.MONTHLY_EVOLUTION,
        CHART_IDS.COMPLETION_TREND,
        CHART_IDS.MONTHLY_STATUS_BREAKDOWN,
      ],
      performance: [],
      geographic: [],
      quality: [CHART_IDS.PROCESS_FUNNEL, CHART_IDS.VOLUME_QUALITY],
    },
    availableFilterFields: {
      dateRange: true,
      provider: false,
      inspector: true,
      status: true,
    },
  },

  
  
  

  [InspectorRoles.INSPECTOR]: {
    canViewReports: true,
    canExportPanorama: false,
    autoFilters: {
      
    },
    availableTabs: ['1', '2'], 
    visibleCharts: {
      overview: [
        CHART_IDS.KPIS,
        CHART_IDS.STATUS_DISTRIBUTION,
        CHART_IDS.INSPECTION_TYPE_DISTRIBUTION,
        
        
        CHART_IDS.TOP_CITIES, 
      ],
      temporal: [
        CHART_IDS.MONTHLY_EVOLUTION,
        CHART_IDS.COMPLETION_TREND,
        CHART_IDS.MONTHLY_STATUS_BREAKDOWN,
        CHART_IDS.YEAR_COMPARISON,
      ],
      performance: [], 
      geographic: [CHART_IDS.GEOGRAPHIC_HEATMAP],
    },
    availableFilterFields: {
      dateRange: true,
      provider: false,
      inspector: false, 
      status: true,
    },
  },
};


export function getReportsAccessConfig(
  userRoles: string[],
  userId?: string,
  providerId?: string
): ReportsAccessConfig {
  
  const rolePriority: UserRole[] = [
    BankRoles.ADMIN_BANK,
    BankRoles.ENG_MANAGEMENT,
    BankRoles.ACCESS_MANAGER,
    BankRoles.BANK_OPERATIONAL,
    BankRoles.ANTI_FRAUD,
    BankRoles.CONSULTANT,
    ProviderRoles.MASTER_PROVIDER,
    ProviderRoles.PROVIDER_OPERATIONAL,
    ProviderRoles.REPORT_ANALYST,
    InspectorRoles.INSPECTOR,
  ];

  
  const userRole = rolePriority.find(role => userRoles.includes(role));

  if (!userRole) {
    
    return {
      canViewReports: false,
      canExportPanorama: false,
      autoFilters: {},
      availableTabs: [],
      visibleCharts: {
        overview: [],
        temporal: [],
        performance: [],
        geographic: [],
      },
      availableFilterFields: {
        dateRange: false,
        provider: false,
        inspector: false,
        status: false,
      },
    };
  }

  
  const baseConfig = ROLE_ACCESS_CONFIGS[userRole];

  
  const config: ReportsAccessConfig = {
    ...baseConfig,
    autoFilters: { ...baseConfig.autoFilters },
  };

  
  if (
    userRole === ProviderRoles.MASTER_PROVIDER ||
    userRole === ProviderRoles.PROVIDER_OPERATIONAL ||
    userRole === ProviderRoles.REPORT_ANALYST
  ) {
    if (providerId) {
      config.autoFilters.providerId = providerId;
    }
  }

  
  if (userRole === InspectorRoles.INSPECTOR) {
    if (userId) {
      config.autoFilters.inspectorId = userId;
    }
  }

  return config;
}


export function isChartVisible(
  chartId: string,
  tab: 'overview' | 'temporal' | 'performance' | 'geographic',
  accessConfig: ReportsAccessConfig
): boolean {
  return accessConfig.visibleCharts[tab].includes(chartId);
}


export function isTabAvailable(tabKey: string, accessConfig: ReportsAccessConfig): boolean {
  return accessConfig.availableTabs.includes(tabKey);
}
